export default "__VITE_ASSET__BVmQALck__"